import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const EmailAddressTooltip = () => (
    <CustomToolTip
        type="?"
        info={
            'If you do not want your personal email address to show in Public Work Search, you may choose to create an email ' +
            'specifically for use in the Public Work Search. Please note that if someone reaches out to you about a work, the ' +
            'email you provide for the Public Contact is where their communication will go.'
        }
        place="right"
    />
)

export default EmailAddressTooltip
